<template>
    <div style="margin-bottom: 10vh;">
        <ul style="list-style:none;margin:10px 0;">
            <li style="padding-bottom:12px;">
                <div>
                    <h3><a
                            href="https://hackernoon.com/developing-an-oauth-20-provider-for-a-resource-server-from-scratch-3v6n3vcm">Developing
                            an OAuth 2.0 Provider for a Resource Server from Scratch</a></h3>
                    <hr>
                    <p>Ever wondered how platforms like Google, Facebook, Twitter, GitHub, etc. provide OAuth functionality.
                        How the OAuth functions, behind the scenes.
                        <br>
                        What happens when you click Sign in with Google or Sign in with Facebook button. If yes, then this
                        article is for you.
                    </p>

                </div>
            </li>
            <li style="padding-bottom:12px;">
                <div>
                    <h3><a
                            href="https://medium.com/@shobhitagarwal756/web-scraping-the-best-way-to-fill-your-database-b94d1c3fa1ff">Web
                            Scraping — An excellent way to load your database</a></h3>
                    <hr>
                    <p>Recently, I was working on a food-based project. I required a list of ingredients and dishes. My
                        first approach was to go on google and search “food database”.
                        <br>
                        It listed a few paid APIs. It also listed a few food websites. After visiting some of them I saw
                        this website https://food.ndtv.com/.
                        <br>
                        The site had all the data which I required, but copying the data would take a lot of time, so I
                        decided to do this with code.
                        <br>
                        This is where web scraping comes into the picture. With scraping, we can get whatever data is on the
                        internet.
                        However, it is unethical to scrape personal data on the internet.
                    </p>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: "Articles"
};
</script>



// WEBPACK FOOTER //
// src/components/articlesComponent.vue